import React from "react";
import { Navigate } from "react-router-dom";

function PrivateRoute({ children }) {

  const token = localStorage.getItem("ekyaAdminToken");

  return token ? children : <Navigate to="/admin" />;
}

export default PrivateRoute;